export const getBarossaValleyData = () => ({
  name: "Barossa Valley",
  country: "Australie",
  description: "La Barossa Valley est l'une des régions viticoles les plus emblématiques d'Australie, réputée pour ses vins de Shiraz puissants et ses vieilles vignes. Cette région bénéficie d'un climat méditerranéen avec des étés chauds et secs, créant des conditions idéales pour la production de vins rouges de qualité exceptionnelle.",
  type: "region",
  subregions: [
    { name: "Barossa Valley", area: "8,000 ha", percentage: "73%", description: "Shiraz emblématique" },
    { name: "Eden Valley", area: "2,000 ha", percentage: "18%", description: "Vins blancs" },
    { name: "High Eden", area: "500 ha", percentage: "5%", description: "Vins d'altitude" },
    { name: "Autres", area: "500 ha", percentage: "4%", description: "Sous-régions diverses" }
  ],
  mapAreas: [
    { region: "Barossa Valley", x: 45, y: 75, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "11,000 ha",
    production: "0.8 million hectolitres",
    subregions: "4 sous-régions principales",
    appellations: "10+ appellations",
    altitude: "200-600m"
  },
  characteristics: {
    climate: "Climat méditerranéen avec étés chauds et secs, hivers doux",
    soil: "Sols argileux, calcaires, sableux, excellente diversité géologique",
    viticulture: "Vieilles vignes, rendements limités, qualité privilégiée"
  },
  wineStyles: {
    red: "Vins rouges puissants et fruités, Shiraz emblématique avec des tanins mûrs",
    white: "Vins blancs frais et aromatiques, Riesling et Chardonnay",
    rosé: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture dans la Barossa Valley remonte à l'arrivée des colons britanniques en 1842. L'immigration allemande a apporté de nouvelles techniques et cépages. Le Shiraz est devenu le cépage emblématique de la région. Aujourd'hui, la Barossa Valley est reconnue mondialement pour ses vins de qualité et ses vieilles vignes.",
  foodPairing: "Cuisine australienne : barbecue, viandes rouges, fromages affinés, cuisine fusion. Les vins de la Barossa Valley s'accordent parfaitement avec la gastronomie internationale et les plats épicés."
}); 